// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_L-z","twoColumnImage":"aM-z"};